// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".establishment-list{border-top:1px solid #dedede;border-bottom:1px solid #dedede}.establishment-list .establishment-tile:hover{background:#eaeaea}", ""]);
// Exports
module.exports = exports;
